<template>
  <div>

    <div class="bar">
      <div class="toolbar van-hairline--bottom">
        <div class="tool-item" @click="orderStatus.show = true">状态：{{ orderStatusList }}<span
            class="caret"></span></div>
      </div>
    </div>

    <van-search v-model.trim="keyword" class="search-bar" shape="round" show-action placeholder="搜索订单号"
                @search="onSearch">
      <div slot="action" @click="onSearch">
        搜索
      </div>
    </van-search>

    <van-list
        class="orderlist"
        v-model="loading"
        :finished="listFinished"
        @load="loadData"
        finished-text="没有更多了">
      <div class="list-item" v-for="(item, index) in list" :key="index">
        <div v-if="showItemList.indexOf('no') !== -1">订单号：{{ item.no }}</div>
        <div v-if="showItemList.indexOf('clerkName') !== -1">店员名称：{{ item.clerkName }}</div>
        <div v-if="showItemList.indexOf('kfName') !== -1">客服名称：{{ item.kfName }}</div>
        <div v-if="showItemList.indexOf('itemContent') !== -1">服务内容：{{ item.itemContent }}</div>
        <div v-if="showItemList.indexOf('totalAmount') !== -1">订单金额：{{ formatPrice(item.totalAmount) }}</div>
        <div v-if="showItemList.indexOf('clerkWagesRatio') !== -1">提成比例：{{ item.clerkWagesRatio }}</div>
        <div v-if="showItemList.indexOf('clerkWagesAmount') !== -1">提成金额：{{ formatPrice(item.clerkWagesAmount) }}</div>
        <div v-if="showItemList.indexOf('startTime') !== -1">下单时间：{{ formatDate(item.startTime, 'MM-DD HH:mm') }}</div>
        <div v-if="showItemList.indexOf('endTime') !== -1">完成时间：{{ formatDate(item.endTime, 'MM-DD HH:mm') }}</div>
        <div v-if="showItemList.indexOf('clerkConfirmTime') !== -1 && item.clerkConfirmTime">确认时间：{{ formatDate(item.clerkConfirmTime, 'MM-DD HH:mm') }}</div>
        <div v-if="showItemList.indexOf('continueRemark') !== -1 && item.continueRemark" class="tags">
          <div>续单：{{ item.continueRemark }}</div>
        </div>
        <div v-if="showItemList.indexOf('remark') !== -1 && item.remark" class="tags">
          <div>备注：{{ item.remark }}</div>
        </div>
        <div class="status">
          <van-tag v-if="item.status == 0" plain type="warning">待确认</van-tag>
          <van-tag v-if="item.status == 1" plain type="success">已确认</van-tag>
        </div>
        <div class="statusBtn" @click.stop="statusBtn(item.id)" v-if="item.status == 0">
          确认
        </div>
      </div>
    </van-list>

    <van-action-sheet
        v-model="orderStatus.show"
        :actions="orderStatus.actions"
        cancel-text="取消"
        @select="onClerkStatus"/>
  </div>
</template>

<script>
import Vue from 'vue';
import {ActionSheet, Dialog, List, CellGroup, Cell, Tag, Toast, Search} from 'vant';
import {getOrderList, confirmOrder , getSetting } from '@/api/clerk/out-order';
import moment from "moment";
import Decimal from "decimal.js";

Vue.use(ActionSheet)
    .use(Dialog)
    .use(List)
    .use(CellGroup)
    .use(Cell)
    .use(Tag)
    .use(Toast)
    .use(Search)


export default {
  name: "out-order-list",

  data() {
    return {
      list: null,
      status: null,
      showItemList: [],
      pageNo: 1,
      pageSize: 10,
      keyword: this.$route.query.orderNo ? this.$route.query.orderNo : null,
      loading: false,
      listFinished: false,
      orderStatus: {
        show: false,
        actions: [
          {name: '全部', value: null},
          {name: '待确认', value: 0},
          {name: '已确认', value: 1}
        ]
      }
    }
  },

  computed: {
    orderStatusList() {
      if (this.status == 0) {
        return '待确认'
      }
      if (this.status == 1) {
        return '已确认'
      }
      return '全部'
    }

  },

  methods: {
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString()
      }
      return ''
    },
    onSearch() {
      this.loadData(true)
    },

    statusBtn(id) {
      Dialog.confirm({
        title: '确定确认吗',
      }).then(() => {
        Toast.loading({
          mask: true,
          message: '加载中...'
        })
        confirmOrder(
            id
        ).then(res => {
          Toast.clear();
          let data = res.data
          if (data.code == 0) {
            this.loadData(true)
            return Toast('确认成功');
          } else {
            Dialog.alert({
              title: '确认失败',
              message: data.msg,
            })
          }
        })
      });
    },

    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },

    onClerkStatus(item) {
      this.status = item.value
      this.orderStatus.show = false
      this.loadData(true)
    },

    loadData(resetFirstPage) {
      // 重置为首页
      if (resetFirstPage) {
        this.pageNo = 1
      }
      // 清空数据
      if (this.pageNo == 1) {
        this.list = [];
      }
      this.loading = true
      getOrderList(
          this.keyword,
          this.status,
          this.pageNo,
          this.pageSize
      ).then(res => {
        this.loading = false
        const data = res.data;
        if (data.code == 0) {
          this.list = this.list.concat(data.list)
          if (data.hasNextPage) {
            this.listFinished = false
          } else {
            this.listFinished = true
          }
        } else {
          this.listFinished = true
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
        this.pageNo++
      })
    },

    loadSetting() {
      getSetting().then(res => {
        const data = res.data;
        if (data.code == 0) {
          this.showItemList = data.setting.showItemList
        } else {
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
      })
    }
  },
  mounted() {
    console.log(this.$route)
    this.loadSetting()
  },
  updated() {
    // 统一替换标签
    this.$replaceLabel(document.body, this.$store.state.label, true)
  }
}
</script>

<style lang="less" scoped>

.bar {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  height: 40px;
  line-height: 40px;
  padding: 8px 0;
  background: #fff;

  .van-search {
    background: none;
    border-radius: 100px;
    border: 1px solid #999;
    height: 33px;
    width: 130px;
    padding: 0;

    .van-cell {
      padding: 0;
    }

    .van-icon {
      //display: none;
    }
  }
}

.orderlist {

  .list-item {
    padding: 10px 20px;
    color: #000;
    position: relative;
    min-height: 77px;

    &:after {
      content: '';
      position: absolute;
      right: 16px;
      left: 16px;
      bottom: 0;
      border-bottom: 1px solid #ebedf0;
      transform: scaleY(.8);
    }

    .dataBox {
      display: flex;

      .wechat {
        margin-right: 30px;
      }
    }

    .tags {
      display: flex;

      .tagsItem {
        margin: 0 6px;
      }
    }

    .status {
      position: absolute;
      top: 20px;
      right: 33px;
    }

    .statusBtn {
      position: absolute;
      top: 45px;
      right: 33px;
      padding: 2px 8px;
      background: #07c160;
      color: #fff;
    }
  }
}


</style>
